import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import HubspotForm from '../hubspot-form/hubspot-form'
import { Modal } from '../modal'
import { Icon } from '../../atoms'
import { breakpoints, useMediaQuery } from '../../..'
import { openHubSpotChat } from '../../../utils'
import { pushToGTM } from '../../../utils/pushToGTM'

const HubspotHelpMeForm = ({ style }: { style?: React.CSSProperties }) => {
  const intl = useIntl()
  return (
    <HubspotForm
      id='hubspot_help_me'
      region='na1'
      portalId='21180823'
      formId={intl.formatMessage({
        id: 'ui.HubspotHelpMeForm.formId',
        defaultMessage: 'ca38e044-5c24-499f-860d-6dc35d910b21',
      })}
      styleForm={style}
    />
  )
}

const ModalHelpMe = ({
  showHelpMe,
  setShowHelpMe,
  speakNowModal,
  setSpeakNowModal,
  onClose,
  style,
  isAfterSignIn,
}: {
  speakNowModal: boolean
  showHelpMe: boolean
  setShowHelpMe: (arg: boolean) => void
  setSpeakNowModal: (arg: boolean) => void
  onClose?: () => void
  style?: React.CSSProperties
  isAfterSignIn?: boolean
}) => {
  const isMobile = useMediaQuery(breakpoints.newMobile)

  const intl = useIntl()
  if (showHelpMe && !isAfterSignIn) {
    pushToGTM({ event: 'opened-popup-demande' })
  }

  return (
    <Modal
      style={style}
      styleChildren={style}
      title={
        showHelpMe ? (
          isAfterSignIn ? (
            <div className={s.showHelpMeTitleAlternative}>
              <div className={s.titleWrapper}>
                <FormattedMessage
                  id='ui.ModalHelpMe.noInscription'
                  defaultMessage='Vous ne souhaitez pas vous inscrire ?'
                />
                <div
                  className={s.iconWrapper}
                  onClick={() => {
                    setSpeakNowModal(false)
                    setShowHelpMe(false)
                    onClose && onClose()
                  }}
                >
                  <div
                    style={{
                      width: 10,
                      height: 10,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Icon
                      name='cross-without-circle'
                      color='black'
                      width={10}
                      height={10}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              id='popup_demande'
              data-gtm='popup_demande'
              className={s.showHelpMeTitleAlternative}
            >
              {isMobile ? (
                <FormattedMessage
                  id='ui.ModalHelpMe.fillBriefTitleMobile'
                  defaultMessage='Partagez-nous votre brief'
                />
              ) : (
                <FormattedMessage
                  id='ui.ModalHelpMe.fillBriefTitle'
                  defaultMessage='Partagez-nous votre brief : on vous envoie nos suggestions personnalisées gratuitement et sous 24h'
                />
              )}
            </div>
          )
        ) : (
          intl.formatMessage({
            id: 'ui.ModalHelpMe.talkToEachOther',
            defaultMessage: 'Parlons-nous maintenant 👋',
          })
        )
      }
      isOpen={speakNowModal}
      closeModal={() => {
        setSpeakNowModal(false)
        setShowHelpMe(false)
        onClose && onClose()
        if (showHelpMe && !isAfterSignIn) {
          pushToGTM({ event: 'closed-popup-demande' })
        }
      }}
    >
      {showHelpMe ? (
        <div>
          {isAfterSignIn && (
            <div className={s.showHelpMeSubTitle}>
              {isMobile ? (
                <FormattedMessage
                  id='ui.ModalHelpMe.fillBriefMobile'
                  defaultMessage='Partagez-nous votre brief'
                />
              ) : (
                <FormattedMessage
                  id='ui.ModalHelpMe.fillBrief'
                  defaultMessage='Partagez-nous votre brief : on vous envoie <highlightedSpan>nos suggestions personnalisées gratuitement</highlightedSpan> et <highlightedSpan>sous 24h</highlightedSpan>'
                  values={{
                    highlightedSpan: (str) => (
                      <span className={s.highlightedSpan}>{str}</span>
                    ),
                  }}
                />
              )}
            </div>
          )}
          <HubspotHelpMeForm style={style} />
        </div>
      ) : (
        <>
          <p className={s.description}>
            <FormattedMessage
              id='ui.ModalHelpMe.askQuestions'
              defaultMessage='Vous avez un projet, des questions ? On vous répond en direct ! '
            />
          </p>
          <a
            id='callUs'
            className={s.ctaContainer}
            href={intl.formatMessage({
              id: 'ui.phoneNumberHref',
              defaultMessage: 'tel:+33189713394',
            })}
          >
            <p>
              📞{' '}
              <FormattedMessage
                id='ui.ModalHelpMe.callUs'
                defaultMessage='Appelez-nous au +33 1 89 71 33 94'
              />
            </p>
            <p className={s.description}>
              <FormattedMessage
                id='ui.ModalHelpMe.availability'
                defaultMessage='Nous sommes disponibles du lundi au vendredi de 9h à 20h'
              />
            </p>
          </a>

          <div
            id='chatWithUs'
            style={{ cursor: 'pointer' }}
            className={s.ctaContainer}
            onClick={() => {
              setSpeakNowModal(false)
              openHubSpotChat()
            }}
          >
            <p>
              💬{' '}
              <FormattedMessage
                id='ui.ModalHelpMe.chat'
                defaultMessage='Chat en direct en bas à droite de votre écran'
              />
            </p>
            <p className={s.description}>
              <FormattedMessage
                id='ui.ModalHelpMe.realHuman'
                defaultMessage='Ce n’est pas un bot mais un vrai être humain qui répond !'
              />
            </p>
          </div>

          <div
            id='formContactUs'
            className={s.ctaContainer}
            onClick={() => setShowHelpMe(true)}
          >
            <p>
              ✍️{' '}
              <FormattedMessage
                id='ui.ModalHelpMe.contactUs'
                defaultMessage='Contactez-nous à tout moment via ce formulaire'
              />
            </p>
            <p className={s.description}>
              <FormattedMessage
                id='ui.ModalHelpMe.lessThanTwoMinutes'
                defaultMessage='Le formulaire est rempli en moins de 2 minutes'
              />
            </p>
          </div>
        </>
      )}
    </Modal>
  )
}

export default ModalHelpMe
